import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import Reports from "@/pages/Reports";
import Pricing from "@/pages/Pricing";
import SampleReport from "@/pages/SampleReport";
import NameNumerology from "@/pages/NameNumerology";
import FAQ from "@/pages/FAQ";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import LegalPage from "@/pages/LegalPage";
import TrackOrder from "@/pages/TrackOrder";
import Checkout from "@/pages/Checkout";
import PaymentResult from "@/pages/PaymentResult";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Orders from "@/pages/admin/Orders";
import OrderDetail from "@/pages/admin/OrderDetail";
import Packages from "@/pages/admin/Packages";
import AuditLog from "@/pages/admin/AuditLog";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/sample-report" element={<SampleReport />} />
            <Route path="/name-numerology" element={<NameNumerology />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/track-order" element={<TrackOrder />} />
            <Route path="/privacy" element={<LegalPage slug="privacy" />} />
            <Route path="/terms" element={<LegalPage slug="terms" />} />
            <Route path="/refund-policy" element={<LegalPage slug="refund" />} />
            <Route path="/disclaimer" element={<LegalPage slug="disclaimer" />} />
          </Route>
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/payment-result" element={<PaymentResult />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="orders" element={<Orders />} />
            <Route path="orders/:orderId" element={<OrderDetail />} />
            <Route path="packages" element={<Packages />} />
            <Route path="audit" element={<AuditLog />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
